import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO = '/tnppl-s2.webp';
const TILE_H = 145;
const MOBILE_H = 200;

const tileW = (it, h) => Math.round(h * (it.w / it.h));

function Row({ items, reverse }) {
  const gap = 12;
  const rowW = items.reduce((s, it) => s + tileW(it, TILE_H) + gap, 0);
  const reps = Math.max(1, Math.ceil(1700 / Math.max(rowW, 1)));
  const base = Array.from({ length: reps }, () => items).flat();
  const dur = Math.min(160, Math.max(30, base.length * 3.5));
  const loop = [...base, ...base];
  return (
    <div className="pg-row" data-testid={`gallery-row-${reverse ? 'b' : 'a'}`}>
      <div className={`pg-track ${reverse ? 'pg-track-rev' : ''}`} style={{ animationDuration: `${dur}s` }}>
        {loop.map((it, i) => (
          <figure key={`${it.id}-${i}`} className="pg-tile" style={{ width: tileW(it, TILE_H), height: TILE_H }}>
            <img src={`${API}${it.url}`} alt="" width={tileW(it, TILE_H)} height={TILE_H} loading="lazy" decoding="async" draggable={false} />
          </figure>
        ))}
      </div>
    </div>
  );
}

function MobileStrip({ items }) {
  return (
    <div className="pg-strip" data-testid="partner-gallery-strip">
      {items.map((it) => (
        <figure key={it.id} className="pg-mtile" style={{ width: tileW(it, MOBILE_H), height: MOBILE_H }}>
          <img src={`${API}${it.url}`} alt="" width={tileW(it, MOBILE_H)} height={MOBILE_H} loading="lazy" decoding="async" />
        </figure>
      ))}
    </div>
  );
}

export function PartnerGallery() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/api/gallery`).then(({ data }) => setItems(data.items || [])).catch(() => {});
  }, []);
  const rowA = items.filter((_, i) => i % 2 === 0);
  const rowB = items.filter((_, i) => i % 2 === 1);

  return (
    <section className="pg-section relative overflow-hidden bg-[#0B0B0C] py-10 md:py-12" id="partners" data-testid="partner-gallery-section">
      <div className="pg-glow" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-8 lg:gap-6 items-center min-w-0">
        <div className="lg:col-span-4 flex flex-col items-start" data-testid="partner-gallery-intro">
          <p className="text-[#C9D82E] font-heading tracking-[0.28em] text-[11px] uppercase mb-5">Official paddle partner</p>
          <img src={LOGO} alt="Cavin's TNPPL Season 2 — Tamil Nadu Pickleball Premier League" className="h-32 md:h-44 w-auto object-contain pg-logo -ml-1" width="364" height="320" loading="lazy" data-testid="partner-gallery-logo" />
          <h2 className="font-display text-white text-base md:text-lg mt-6 leading-snug">Cavin's TNPPL Season 2</h2>
          <p className="text-zinc-400 text-sm mt-2 max-w-xs leading-relaxed">
            DYSSC equipped the podium of the Tamil Nadu Pickleball Premier League — 12 district franchises, 168 players, one paddle on the winners' stage.
          </p>
        </div>

        {items.length > 0 && (
          <>
            <div className="hidden lg:block lg:col-span-8 pg-stage" data-testid="partner-gallery-wall">
              <div className="pg-wall">
                <Row items={rowA} />
                {rowB.length > 0 && <Row items={rowB} reverse />}
                <span className="pg-sweep" aria-hidden="true" />
              </div>
            </div>
            <div className="lg:hidden -mx-4 sm:-mx-6 min-w-0 w-full max-w-full">
              <MobileStrip items={items} />
              <p className="px-4 sm:px-6 mt-3 text-[11px] uppercase tracking-[0.2em] text-zinc-500">Swipe → {items.length} photos from the league</p>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
